import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider, theme } from 'antd';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorPrimary: '#1677ff',
          },
          components: {
            Button: {
              controlHeightLG: 48,
            },
            Input: {
              controlHeightLG: 48,
            },
            Select: {
              controlHeightLG: 48,
            },
            Switch: {
              handleSizeLG: 28,
            },
          },
        }}
      >
        <App />
      </ConfigProvider>
    </AuthProvider>
  </React.StrictMode>
);
